/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useContext, useEffect, useState} from "react";
import {
    AdUnitsOutlined,
    ArticleOutlined,
    BadgeOutlined,
    GroupAddOutlined,
    LayersOutlined,
    LibraryBooksOutlined,
    MarkUnreadChatAltOutlined,
    ScatterPlotOutlined,
    SchoolOutlined
} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import {usuarioContext} from "../App";
import Seccion_Usuarios from "./Secciones/Seccion_Usuarios";
import Seccion_Adicional from "./Secciones/Seccion_Adicional";
import Seccion_Categorias_Formacion from "./Secciones/Seccion_Categorias_Formacion";
import Seccion_Potenciales from "./Secciones/Seccion_Potenciales";
import datos from '../Recursos/Prueba.json'
import axios from "axios";
import {PAISESINDICATIVO} from "../Modulo_formularios/Recursos/indicativos";
import {obtenerCol} from "../Servicios/BD/obtenerCol";
import {guardarDoc} from "../Servicios/BD/guardarDoc";
import Seccion_Programas from "./Secciones/Seccion_Programas";
import Seccion_Potenciales_Espacio from "./Secciones/Seccion_Potenciales_Espacio";
import Seccion_Escuela from "./Secciones/Seccion_Escuela";
import Seccion_Anuncios from "./Secciones/Seccion_Anuncios";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)
    const {usuario} = useContext(usuarioContext)

    const [open, setOpen] = useState(false)
    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }


    const {Provider} = contexBarra;


    const enviarMensaje = () => {


        let arr = []

        for (let i = 0; i < datos.length; i++) {

            let obj = {
                NOMBRE: datos[i].nombre,
                TELEFONO: obtenerCelular(datos[i]),
            }
            arr.push(obj)
        }

        let data = JSON.stringify(arr);

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/678cd114-361f-48ed-9162-b6439b5fa5d4', //test
            //url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/bf2c6e41-149e-4be4-ae23-35508000632e',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios.request(config)
            .then((response) => {
                console.log(JSON.stringify(response.data));
            })
            .catch((error) => {
                console.log(error);
            });


    }

    const obtenerCelular = (data) => {

        if (!data.pais || !data.celular) {
            return 0
        }

        let index = PAISESINDICATIVO.findIndex((it) => it.nameES === data.pais)
        let indicativo = PAISESINDICATIVO[index].phoneCode
        if (index < 0) {
            return 0
        }

        let limpio1 = data.celular.replaceAll(' ', '')
        let limpio2 = limpio1.replaceAll('-', '')

        return indicativo + limpio2


    }

    const actualizaDatos = async () => {

        let dox = await obtenerCol('potencialesEspacios')
        let datos = dox.data

        for (let i = 0; i < datos.length; i++) {

            let obj = {
                id: new Date().getTime() + '' + i,
                idUsuario: datos[i].id,
                fecha: 1780182000000,
                nombre: 'Noti Recordatorio Final Donacion',
                descripcion: '[nombre], gracias por haber sido parte de este espacio en Creencia Central. Sí deseas apoyar este tipo de encuentros, puedes hacerlo aquí, regálanos un cafe, lo apreciaremos mucho 👇🏼\n' +
                    '\n' +
                    ' 🔗 https://cafecito.app/creenciacentral\n',
            }
            await guardarDoc('historial', obj)
        }

    }


    useEffect(() => {


    }, [usuario]);
    return (
        <Grid
            container
            size={12}
        >

            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>

            {/*<Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', p: 3}}>
                <Button onClick={() => actualizaDatos()}>
                    Enviar
                </Button>
            </Grid>*/}

        </Grid>
    )

}
export default Dashboard

const secciones = [
    {
        nombre: 'Potenciales (CRM)',
        icono: GroupAddOutlined,
        camino: '/Potenciales',
        categoria: 'Programas',
        Componente: <Seccion_Potenciales/>
    },
    {
        nombre: 'Programas',
        icono: LibraryBooksOutlined,
        camino: '/Programas',
        categoria: 'Pagina',
        Componente: <Seccion_Programas/>
    },
    {
        nombre: 'Escuelas',
        icono: SchoolOutlined,
        camino: '/Escuelas',
        categoria: 'Pagina',
        Componente: <Seccion_Escuela/>
    },
    {
        nombre: 'Mensajes Masivos',
        icono: MarkUnreadChatAltOutlined,
        camino: '/Mensajes',
        categoria: 'Pagina',
        Componente: <h1>Deshabilitado</h1>
    },
    {
        nombre: 'Categorias Programas',
        icono: ScatterPlotOutlined,
        camino: '/CategoriasProgramas',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Categorias_Formacion/>
    },
    {
        nombre: 'Anuncios',
        icono: AdUnitsOutlined,
        camino: '/Anuncios',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Anuncios/>
    },
    {
        nombre: 'Documentos',
        icono: ArticleOutlined,
        camino: '/Documentos',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <h1>Deshabilitado</h1>
    },
    {
        nombre: 'Adicionales',
        icono: LayersOutlined,
        camino: '/Adicionales',
        categoria: 'Configuraciones',
        Componente: <Seccion_Adicional/>
    },
    {
        nombre: 'Usuarios',
        icono: BadgeOutlined,
        camino: '/Usuarios',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Usuarios/>
    }
]

const seccionesID = [
    {

        camino: '/Potenciales/:id',
        Componente: <Seccion_Potenciales_Espacio/>
    }

]

const seccionesPerfil = []

const notificaciones = {}